import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ViewChild,
  OnInit,
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import {
  CellComponent,
  CellContext,
  ColorOptions,
  GridData,
} from '@grid/models';

@Component({
  selector: 'app-color-picker-menu',
  templateUrl: './color-picker-menu.component.html',
  styleUrls: ['./color-picker-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@UntilDestroy()
export class ColorPickerMenuComponent
  implements CellComponent<GridData>, OnInit
{
  @Input({ required: true }) context!: CellContext<GridData>;
  @Input({ required: true }) options: ColorOptions;

  @ViewChild(MatMenuTrigger, { static: true }) matMenuTrigger!: MatMenuTrigger;

  ngOnInit(): void {
    // this is needed to keep the cell from being stuck
    // in edit mode if the user click on backdrop on color edit
    this.matMenuTrigger.menuClosed.pipe(untilDestroyed(this)).subscribe(() => {
      this.context.cell.actions?.setDelegateEditState(false);
    });

    // this is needed for the case the user first clicks the backdrop
    // and then tries again to edit the color
    this.matMenuTrigger.menuOpened.pipe(untilDestroyed(this)).subscribe(() => {
      this.context.cell.actions?.setDelegateEditState(true);
    });
  }
}
